import { useState } from 'react';
import CustomDrawer from '../../../components/customDrawer';
import UseSalesReturnDetails from '../hooks/useSalesReturnDetails';
import Header from '../../../../components/Header';
import PageLoader from '../../../../../component/PageLoader';
import SalesReturnTabs from './salesReturnTabs';
import { getDate } from '../../../../../utils/dateUtils';
import SalesReturnPdfView from './salesReturnPdfView';
import CustomAlertModel from '../../../components/customAlertModel';
import Button from '../../../../../component/ui/Button';
import { toast } from 'react-toastify';
import { adjustSalesReturnRefundAmount } from '../../../../../services/sales_return';
import Modal from '../../../../../component/modal/Modal';

const SalesReturnDetails = () => {
	const {
		id,
		loader,
		returnsDetails,
		navigate,
		suburl,
		generateSalesReturnsPdf,
		handleDeleteSalesReturn,
		isDeleteModelOpen,
		setIsDeleteModalOpen,
		setIsCreateCreditNoteModalOpen,
		isCreateCreditNoteModelOpen,
		handleCreateCreditNote,
		getSRDetails,
	} = UseSalesReturnDetails();
	const [drawerType, setDrawerType] = useState('');
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [isOpenModelForReturns, setIsOpenModelForReturns] = useState(false);

	async function settleRefundAmount(value) {
		try {
			var body = {
				sales_return_id: id,
				isRefund_amount: value,
			};
			await adjustSalesReturnRefundAmount(body);
			toast.success('Adjust refund amount successfully');
			getSRDetails();
		} catch (error) {
			toast.error(error.message || 'something went wrong!');
		}
	}

	return (
		<div
			style={{
				backgroundColor: '#EDEDF7',
				height: '100vh',
				display: 'flex',
				flexDirection: 'column',
			}}
		>
			<div
				style={{
					position: 'sticky',
					top: 0,
					zIndex: 30,
					backgroundColor: '#EDEDF7',
					boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
				}}
			>
				<Header
					headerTitle="Sales Return Details"
					closeButton={{
						showCloseButton: true,
						handler: () => navigate(`/user/${suburl}/sales-return`),
					}}
					buttons={[
						returnsDetails && {
							id: 1,
							title: 'Share',
							isDropdown: true,
							options: [
								{
									id: '1.1',
									handler: () => navigate(`/user/${suburl}/sales-return-send-emails/${id}`),
									title: 'Send Email',
								},
								{
									id: '1.3',
									handler: () => generateSalesReturnsPdf('print', false),
									title: 'Pdf/Print',
								},
							],
						},

						returnsDetails && {
							id: 2,
							title: 'More Actions',
							isDropdown: true,
							options: [
								{
									id: '1.1',
									handler: () => {
										if (returnsDetails?.sales_credit_notes_damage_returns?.length > 0) {
											toast.error('Credit Note already created. Cannot update the Sales Return.');
										} else {
											navigate(`/user/${suburl}/sales-return-create/${id}`);
										}
									},
									title: 'Edit',
								},
							],
						},

						returnsDetails && {
							className: 'btn-gray mt-0 px-4 ',
							button: 'Delete',
							handler: () => {
								if (returnsDetails?.sales_credit_notes_damage_returns?.length > 0) {
									setIsOpenModelForReturns(true);
								} else {
									setIsDeleteModalOpen(true);
								}
							},
						},
					].filter(Boolean)}
					dropDownButtons={[]}
				/>

				<SalesReturnTabs
					invoices={
						returnsDetails?.sales_return_invoices?.length > 0
							? returnsDetails?.sales_return_invoices.map((ele) => ({
									id: ele.invoice?.id,
									DATE: getDate(ele?.invoice?.date),
									INVOICE: ele?.invoice?.invoice_number || 'N/A',
									STATUS: ele?.invoice?.status || 'N/A',
									AMOUNT: ele?.invoice?.total_amount || 'N/A',
								}))
							: []
					}
					creditNoteList={
						returnsDetails?.sales_credit_notes_damage_returns?.length > 0
							? returnsDetails?.sales_credit_notes_damage_returns?.map((ele) => {
									return {
										id: ele.credit_note_id,
										DATE: getDate(ele?.credit_note?.date),
										'CREDIT NOTE #': ele?.credit_note?.credit_note_number || 'N/A',
										'CUSTOMER NAME': returnsDetails.customer?.name || 'N/A',
										STATUS: ele?.credit_note?.status,
										TYPE:
											ele?.credit_note?.credit_note_type === 1
												? 'Damaged/Return Goods'
												: ele?.credit_note?.credit_note_type === 2
													? 'Excess Payment'
													: 'Advance Payment',
										AMOUNT: Number(ele?.credit_note?.total_credit_amount).toFixed(2),
									};
								})
							: []
					}
				/>

				{returnsDetails?.payment_mode?.payment_method_name?.toLowerCase().includes('credit') &&
					returnsDetails.status === 'Open' && (
						<div
							style={{
								backgroundColor: '#FFC008',
								padding: '10px 0px',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								borderTop: '1px solid #ccc',
							}}
						>
							<div
								style={{ color: '#000', fontSize: '14px', fontWeight: '600', marginRight: '10px' }}
							>
								Action Required: Excess/Unused amount pending. Adjusting this amount is required.
							</div>
							<Button
								type="button"
								className="mx-1 btn-primary add-pro"
								button="Create Credit Note"
								onClick={() => settleRefundAmount(false)}
							/>
							<div className="mx-2" />
							<Button
								type="button"
								className="mt-0 btn-primary add-pro"
								button="Refund Amount"
								onClick={() => settleRefundAmount(true)}
							/>
						</div>
					)}
			</div>

			{loader.isLoading && loader.status === 'detail' ? (
				<PageLoader />
			) : (
				<SalesReturnPdfView
					returnDetails={returnsDetails}
					setDrawerType={setDrawerType}
					setIsDrawerOpen={setIsDrawerOpen}
					settleRefundAmount={settleRefundAmount}
				/>
			)}
			{/* {isUpdateStatusModelOpen && (
				<CustomUpdateStatusModel
					updateStatusModel={isUpdateStatusModelOpen}
					setUpdateStatusModel={setUpdateStatusModelOpen}
					statusText={'Are you sure you want to change update status of Invoice?'}
					handleUpdateStatus={handleUpdateStatus}
				/>
			)} */}
			{isOpenModelForReturns && (
				<Modal
					className="deleteVendorsModal"
					title="Sales Return Delete"
					isOpen={isOpenModelForReturns}
					onClose={() => {
						setIsOpenModelForReturns(false);
					}}
					cancelButton={() => {
						setIsOpenModelForReturns(false);
					}}
				>
					<div
						style={{
							textAlign: 'center',
							backgroundColor: '#E6F5FF',
							padding: '20px 10px',
							marginBottom: '20px',
							borderRadius: '5px',
							fontWeight: '600',
							color: 'black',
						}}
					>
						{'Please delete the associated record ' +
							returnsDetails?.sales_credit_notes_damage_returns[0]?.credit_note
								?.credit_note_number +
							' first before deleting this Sales Return.'}
					</div>
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							gap: 10,
							justifyContent: 'end',
						}}
					>
						<Button
							type="button"
							button="Cancel"
							className="mt-0 px-4 btn-gray relative"
							onClick={() => setIsOpenModelForReturns(false)}
						/>

						<Button
							type="button"
							button={
								'Go to Dependent Record (' +
								returnsDetails?.sales_credit_notes_damage_returns[0]?.credit_note
									?.credit_note_number +
								')'
							}
							className="mt-0 px-4 btn-primary relative"
							onClick={() => {
								navigate(
									`/user/${suburl}/sales/credit-note-details/${returnsDetails?.sales_credit_notes_damage_returns[0]?.credit_note?.id}`,
									{},
								);
							}}
						/>
					</div>
				</Modal>
			)}
			{isDeleteModelOpen && (
				<CustomAlertModel
					setIsAlertModelOpen={setIsDeleteModalOpen}
					isAlertModelOpen={isDeleteModelOpen}
					customText={'Are you sare you want to delete'}
					saleTypeName={'Sales Return'}
					title={'Sales Return Delete'}
					handleBulk={handleDeleteSalesReturn}
				/>
			)}
			{isCreateCreditNoteModelOpen && (
				<CustomAlertModel
					setIsAlertModelOpen={setIsCreateCreditNoteModalOpen}
					isAlertModelOpen={isCreateCreditNoteModelOpen}
					customText={'Are you sare you want to create credit note from sales return'}
					saleTypeName={'Credit Note'}
					title={'Create Credit Note'}
					handleBulk={handleCreateCreditNote}
				/>
			)}

			{
				<CustomDrawer
					isOpen={isDrawerOpen}
					onClose={() => setIsDrawerOpen(false)}
					id={drawerType === 'customer' ? returnsDetails.customer_id : null}
					drawerType={drawerType}
					activeDrawer={'Details'}
				/>
			}
		</div>
	);
};
export default SalesReturnDetails;
